import { useSelector, useDispatch } from 'react-redux';
import Icon, { ICON_CASINO_SEVEN, ICON_CIRCLE_CHECKMARK_FILLED } from '~/components/icon/index.js';
import useTranslations from '~/components/translation/use-translations.ts';
import {
	optedinInhouseJackpotsSelector,
	setIsModalShown,
	mainInhouseJackpotSelector
} from '~/components/casino-shared/inhouse-jackpot/ducks';
import {
	InhouseJackpotButtonButtonWrapper,
	InhouseJackpotText,
	InhouseJackpotIconContainer
} from '~/components/casino-shared/inhouse-jackpot/inhouse-jackpot-button.styled';
import { selectInhouseJackpotIconUrl } from '~/components/brand/ducks/selectors';

const textKeys = ['INHOUSE_JACKPOT_BTN'];

const InhouseJackpotButton = ({ isDesktop, orientation }) => {
	const dispatch = useDispatch();
	const { translations } = useTranslations(textKeys);
	const optedInJackpots = useSelector(optedinInhouseJackpotsSelector);
	const inhouseJackpotIconUrl = useSelector(selectInhouseJackpotIconUrl);
	const mainInhouseJackpotId = useSelector(mainInhouseJackpotSelector);
	const isOptedin = optedInJackpots?.includes(mainInhouseJackpotId);

	return (
		<InhouseJackpotButtonButtonWrapper
			data-at="inhouse-jackpot-button"
			isOptedin={isOptedin}
			isDesktop={isDesktop}
			orientation={orientation}
			onClick={() => dispatch(setIsModalShown(true))}
		>
			<InhouseJackpotText
				isOptedin={isOptedin}
				isDesktop={isDesktop}
				orientation={orientation}
				data-at="inhouse-jackpot-button-text"
			>
				{translations.INHOUSE_JACKPOT_BTN}
			</InhouseJackpotText>
			<InhouseJackpotIconContainer
				isOptedin={isOptedin}
				isDesktop={isDesktop}
				inhouseJackpotIconUrl={inhouseJackpotIconUrl}
				data-at="inhouse-jackpot-button-icon"
			>
				{inhouseJackpotIconUrl ? null : (
					<Icon
						width={isDesktop ? 20 : 18}
						height={isDesktop ? 20 : 18}
						type={isOptedin ? ICON_CIRCLE_CHECKMARK_FILLED : ICON_CASINO_SEVEN}
					/>
				)}
			</InhouseJackpotIconContainer>
		</InhouseJackpotButtonButtonWrapper>
	);
};

export default InhouseJackpotButton;
